/**
 * Bump-Animation der Mengenwahl.
 *
 * Dawns quantity-input loest nach jedem Tastendruck ein change-Ereignis
 * auf dem Eingabefeld aus (auch beim Tippen). Ein Zuhoerer auf dem
 * Dokument genuegt damit fuer Produktseite UND Warenkorb-Schublade —
 * auch fuer Felder, die die Schublade erst spaeter nachlaedt.
 *
 * Die Klasse wird nach dem Ende der Uebergangszeit wieder entfernt,
 * damit der naechste Klick erneut federt. transitionend allein reicht
 * nicht: bei prefers-reduced-motion gibt es keinen Uebergang, das
 * Ereignis bliebe aus und die Klasse haengen — deshalb der Zeitgeber.
 */
(function () {
  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input.classList || !input.classList.contains('quantity__input')) return;
    input.classList.remove('bump');
    // Neustart des Uebergangs erzwingen
    void input.offsetWidth;
    input.classList.add('bump');
    clearTimeout(input._bumpTimer);
    input._bumpTimer = setTimeout(function () {
      input.classList.remove('bump');
    }, 380);
  });
})();
